import { postApi } from "../api";

export const createCampaignApi = (data) => postApi(`/campaign/create`, data);